const defaultLayout = () =>
`
  <Loading />
`;

const simpleLayout = () =>
`
  <Loading simple />
`;

const buttonsTemplates = {
  deafault: defaultLayout(),
  simple  : simpleLayout(),
};

export default buttonsTemplates;



// WEBPACK FOOTER //
// ./src/containers/elements/Loadings/constants/loadingsTemplates.js